import { Wording } from '@/types';

export const COOKING_WORDING_FR: Wording = {
  components_header_media_content: 'Vidéos de cuisine',
  components_header_media_1: '',
  components_header_media_2: '',
  components_header_text1: 'Recettes',
  components_header_text2: 'Blog',
  components_header_members: 'Membres',
  hero_text: 'Cuisinez avec passion, mangez avec joie',
  hero_button_text: 'Commencez à cuisiner dès aujourd\'hui',
  components_ressources_section_title: 'RESSOURCES',
  components_ressources_subheader_text: 'Toutes les ressources dont vous avez besoin pour apprendre, cuisiner et créer de meilleurs plats',
  components_ressources_span_text: 'Découvrez une riche collection de recettes vidéo, de guides de cuisine détaillés et de conseils d\'experts sur les accords de saveurs, la présentation des plats et la créativité culinaire.',
  components_ressources_card_1_title: 'Inspiration culinaire',
  components_ressources_card_1_text: 'Trouvez l\'inspiration grâce à des recettes créatives et des vidéos de cuisine.',
  components_ressources_card_2_title: 'Connaissances culinaires',
  components_ressources_card_2_text: 'Apprenez les techniques culinaires essentielles, les combinaisons de saveurs et les bases des accords mets-vins grâce à des guides clairs et pratiques.',
  components_ressources_link: 'Regarder des vidéos',
  components_notes_and_google_title_1: 'Éducation culinaire',
  components_notes_and_google_title_2: 'Cuisine quotidienne',
  components_notes_and_google_title_3: 'Compétences culinaires constantes',
  components_review_google_text: 'Avis sur Google',
  media_content_section_title: 'Vidéos de cuisine',
  media_content_section_subheader_text: 'Explorez des recettes et des vidéos de cuisine étape par étape.',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Plus de vidéos',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Guides et articles',
  text2_section_button_more: 'Plus d\'articles',
  components_text1_section_title: 'RECETTES',
  components_text1_subheader_text: 'De délicieuses recettes pour la cuisine de tous les jours',
  components_text1_span_text: 'Découvrez des recettes faciles à suivre, conçues pour les repas de tous les jours, avec des étapes claires et d\'excellents résultats.',
  components_text1_card_1_title: 'Commencez votre journée du bon pied',
  components_text1_card_1_text: 'Des recettes simples et savoureuses pour bien commencer la journée.',
  components_text1_card_3_title: 'Idées de déjeuners savoureux',
  components_text1_card_3_text: 'Des recettes de déjeuner délicieuses, faciles à préparer et pleines de saveurs.',
  components_text1_card_2_title: 'Recettes de dîner réconfortantes',
  components_text1_card_2_text: 'Des recettes de dîner réconfortantes et savoureuses, parfaites pour des soirées détente à la maison.',
  components_text1_link: 'Voir toutes les recettes',
  components_footer_text: 'Apprenez à mieux cuisiner, créez de meilleurs plats : votre cuisine, votre parcours.',
  components_footer_info: 'Info',
  components_footer_registration_number: 'Numéro d\'immatriculation',
  components_footer_legal: 'Légal',
  components_footer_terms: 'Termes et conditions',
  components_footer_privacy: 'politique de confidentialité',
  button_load_more: 'Charger plus',
  page_media_1_content_hero_text: 'Découvrez des vidéos de cuisine faciles pour tous les goûts',
  page_text1_hero_text: 'Recettes',
  page_text1_section_title: 'Conseils de cuisine',
  page_text1_subheader_text: 'Recettes',
  page_text2_hero_text: 'Notre blog',
  page_text2_section_title: 'Blog',
  page_text2_subheader_text: 'Guides et articles',
  enter_email_title: 'Veuillez saisir votre adresse e-mail pour continuer',
  enter_email_placeholder_email: 'E-mail',
  enter_email_button_enter: 'Entrer',
  components_login_success_text: 'Connexion réussie !',
  components_card_link_media_content: 'Regardez maintenant',
  components_card_link_text1_content: 'Voir la recette',
  components_card_link_text2_content: 'Voir l\'article',
};